export const WIDTHS = {
    collapsed: 56,
    expanded: 237,
};

export const COLLAPSE_ANIMATION_DURATION = 300;
